import React, { ReactNode } from 'react'
import { CSSTransition } from 'react-transition-group'
import { css, cx } from '@emotion/css'

const time = 250
const timeCssVal = `${time}ms`
const transitionName = 'Contrast_transitionListItem'
const listItemHeight = '19px'

export interface TransitionListItemProps {
  readonly className?: string
  readonly children: ReactNode
}

const transitionCss = css`
  &.${transitionName}-enter {
    max-height: 0;
    opacity: 0.01;
  }
  &.${transitionName}-enter.${transitionName}-enter-active {
    max-height: ${listItemHeight};
    opacity: 1;
    transition: max-height ${timeCssVal} ease-in, opacity ${timeCssVal} ease-in;
  }
  &.${transitionName}-exit {
    max-height: ${listItemHeight};
    opacity: 1;
  }
  &.${transitionName}-exit.${transitionName}-exit-active {
    max-height: 0;
    opacity: 0.01;
    transition: max-height ${timeCssVal} ease-out, opacity ${timeCssVal} ease-in;
  }
`

export function TransitionListItem({
  className,
  children,
  ...props
}: TransitionListItemProps) {
  return (
    <CSSTransition {...props} timeout={time} classNames={transitionName}>
      <li
        className={className ? cx(transitionCss, className) : transitionCss}
        children={children}
      />
    </CSSTransition>
  )
}
